import React from "react";
import { observer } from "mobx-react-lite";

import { translationService } from "../../../../../services/translation/TranslationService";
import "./TotalPrice.scss";

export const TotalPrice = observer((props: { totalPrice: string }) => {
  return (
    <div className="price-vat-container">
      <div className="total-price">
        <span className="extra-large-label">{`${props.totalPrice} €`}</span>
        <span className="extra-large-size-grey-label">
          {`${translationService.translate("SubscriptionPlans.card.total-price")}`}
        </span>
      </div>
      <div className="small-opacity-label with-new-line">
        {translationService.translate("SubscriptionPlans.card.vat-not-included")}
      </div>
    </div>
  );
});
